/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { calculateDiscountItemModifierSchema } from "./calculateDiscountItemModifierSchema.ts";

export const calculateDiscountItemGroupModifierSchema = calculateDiscountItemModifierSchema.describe("Базовый сериализатор рассчета скидки по позициям.");
